export const REQUEST_STATUS = {
  NEW: 'new',
  DENIED: 'denied',
  DELAYED: 'delayed',
  ACCEPTED: 'accepted',
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  ASSIGNED: 'assigned',
  REASSIGNED: 'reassigned',
  CHANGE_REQUEST: 'change_request',
  AWAITING_REVISION: 'awaiting_revision',
  ARCHIVED: 'archived',
  PAYMENT_PENDING: 'payment_pending',
  PAYMENT_FAILED: 'payment_failed',
  UNKNOWN: 'unknown',
} as const

export const GROUPED_REQUEST_STATUS = {
  NEW: 'new',
  VOIDED: 'voided',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  UNKNOWN: 'unknown',
} as const
